(() => {
  const init = (root) => {
    if (!root || root.dataset.lmReady === 'true') return;
    root.dataset.lmReady = 'true';

    const dataEl = root.querySelector('[data-lm-variant-data]');
    if (!dataEl) return;

    let variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (error) {
      console.error('Lémur product selector: invalid variant data', error);
      return;
    }


    // Read-only mapping: retain the original Shopify variant IDs/SKUs and map
    // inconsistent Gelato option names to a common storefront presentation.
    const normalizeSize = (text) => {
      const match = String(text || '').match(/(?:30\s*[x×]\s*40|45\s*[x×]\s*60|60\s*[x×]\s*80|70\s*[x×]\s*100)\s*cm/i);
      return match ? match[0].replace(/\s+/g, '').replace(/×/g, 'x').toLowerCase().replace(/cm$/, ' cm') : '';
    };
    variants = variants.map((variant) => {
      const source = [variant.title || '', ...(variant.options || [])].join(' ');
      const type = /\bcanvas\b/i.test(source)
        ? '__CANVAS__'
        : /\bframed\b/i.test(source) ? '__FRAMED__' : '__PRINT__';
      const lower = source.toLowerCase();
      let frame = '__NO_FRAME__';
      if (type === '__FRAMED__') {
        frame = /dark\s*wood\s*frame/.test(lower) ? 'dark-wood'
          : /black\s*frame/.test(lower) ? 'black'
          : /white\s*frame/.test(lower) ? 'white'
          : /wood\s*frame/.test(lower) ? 'wood' : '';
      }
      const preference = /ready-to-hang/i.test(source) ? 9
        : /not assembled/i.test(source) ? 0
        : /\bslim\b/i.test(source) ? 1
        : /\bthick\b/i.test(source) ? 2 : 3;
      return { ...variant, rawOptions: variant.options, options: [type, normalizeSize(source), frame], preference };
    }).filter((variant) => variant.options[1]).sort((a, b) => a.preference - b.preference);

    const framedValue = root.dataset.framedValue;
    const unframedValue = root.dataset.unframedValue;
    const canvasValue = root.dataset.canvasValue;
    const currency = root.dataset.currency || 'SEK';
    const productScope = root.closest('product-info') || document;
    const canvasMediaIds = new Set(
      variants
        .filter((variant) => variant.options?.[0] === canvasValue && variant.mediaId)
        .map((variant) => String(variant.mediaId))
    );

    const typeButtons = Array.from(root.querySelectorAll('[data-lm-type]'));
    const sizeButtons = Array.from(root.querySelectorAll('[data-lm-size]'));
    const frameButtons = Array.from(root.querySelectorAll('[data-lm-frame]'));
    const frameContainer = root.querySelector('.lm-ref-frame-modal__options');
    const framePriority = (name) => {
      const value = String(name || '').toLowerCase();
      if (value === '__no_frame__') return -1;
      if (value.includes('black')) return 0;
      if (value.includes('white')) return 1;
      if (value.includes('dark wood')) return 3;
      if (value.includes('wood')) return 2;
      return 4;
    };
    if (frameContainer && root.dataset.productPosition === '2') {
      frameButtons.sort((a, b) => framePriority(a.dataset.lmFrame) - framePriority(b.dataset.lmFrame))
        .forEach((button) => frameContainer.appendChild(button));
    }
    const mainPrice = root.querySelector('[data-lm-current-price]');
    const mainButton = root.querySelector('[data-lm-main-add]');
    const mainButtonPrice = root.querySelector('[data-lm-button-price]');
    const frameNote = root.querySelector('[data-lm-frame-note]');
    const modal = root.querySelector('[data-lm-frame-modal]');
    const variantInput = root.querySelector('[data-lm-variant-input]');
    const hiddenSubmit = root.querySelector('.lm-ref-product__hidden-submit');
    const continueButton = root.querySelector('[data-lm-frame-continue]');
    const continueLabel = root.querySelector('[data-lm-continue-label]');
    const afterAdd = root.querySelector('[data-lm-after-add]');

    const state = {
      type: 'print',
      size: root.dataset.defaultSize,
      frame: '__NO_FRAME__'
    };

    const movePostPurchaseHelpers = () => {
      if (!afterAdd) return;

      const shippingSection =
        document.querySelector('[id$="__17914603465968d134"]') ||
        document.querySelector('[id*="17914603465968d134"]');
      const bestSellersSection =
        document.querySelector('[id$="__featured_collection_EifRde"]') ||
        document.querySelector('[id*="featured_collection_EifRde"]');

      [shippingSection, bestSellersSection].forEach((section) => {
        if (section && section !== afterAdd && !afterAdd.contains(section)) {
          afterAdd.appendChild(section);
        }
      });
    };

    const findVariant = (productValue, size, frameValue = null) => {
      const candidates = variants.filter((variant) => {
        if (variant.options?.[0] !== productValue) return false;
        if (variant.options?.[1] !== size) return false;
        if (frameValue !== null && variant.options?.[2] !== frameValue) return false;
        return true;
      });
      return candidates.find((variant) => variant.available) || candidates[0] || null;
    };

    const currentBaseVariant = () =>
      state.type === 'canvas'
        ? findVariant(canvasValue, state.size)
        : findVariant(unframedValue, state.size);

    const currentFinalVariant = () => {
      if (state.type === 'canvas') return findVariant(canvasValue, state.size);
      if (state.frame === '__NO_FRAME__') return findVariant(unframedValue, state.size);
      return findVariant(framedValue, state.size, state.frame);
    };

    const formatDelta = (minor) => {
      if (!Number.isFinite(minor)) return '';
      const safeMinor = Math.max(0, minor);
      try {
        return '+' + new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency,
          maximumFractionDigits: 0
        }).format(safeMinor / 100);
      } catch (_) {
        return '+' + Math.round(safeMinor / 100) + ' ' + currency;
      }
    };

    const mediaIdFromValue = (value) => {
      const match = String(value || '').match(/(\d+)$/);
      return match ? match[1] : '';
    };

    const syncCanvasGallery = (activeCanvasMediaId = null) => {
      if (!canvasMediaIds.size) return;

      const gallery = productScope.querySelector('media-gallery') || document.querySelector('media-gallery');
      const activeId = activeCanvasMediaId ? String(activeCanvasMediaId) : null;

      productScope.querySelectorAll('li.product__media-item[data-media-id]').forEach((item) => {
        const id = mediaIdFromValue(item.dataset.mediaId);
        if (!canvasMediaIds.has(id)) return;
        const shouldShow = state.type === 'canvas' && id === activeId;
        item.hidden = !shouldShow;
        item.classList.toggle('lm-canvas-variant-media', true);
      });

      productScope.querySelectorAll('li.thumbnail-list__item[data-target]').forEach((item) => {
        const id = mediaIdFromValue(item.dataset.target);
        if (!canvasMediaIds.has(id)) return;
        item.hidden = true;
        item.classList.toggle('lm-canvas-variant-media', true);
      });

      document.querySelectorAll('product-modal [data-media-id]').forEach((item) => {
        const id = mediaIdFromValue(item.dataset.mediaId);
        if (!canvasMediaIds.has(id)) return;
        item.hidden = !(state.type === 'canvas' && id === activeId);
      });

      gallery?.elements?.viewer?.resetPages?.();
      gallery?.elements?.thumbnails?.resetPages?.();

      const visibleSlides = Array.from(
        productScope.querySelectorAll('li.product__media-item[data-media-id]')
      ).filter((item) => !item.hidden);
      const total = productScope.querySelector('.slider-counter--total');
      if (total && visibleSlides.length) total.textContent = String(visibleSlides.length);
    };

    const updateMedia = (variant) => {
      const mediaId = variant?.mediaId ? String(variant.mediaId) : null;
      syncCanvasGallery(state.type === 'canvas' ? mediaId : null);
      if (!mediaId) return;

      const gallery = productScope.querySelector('media-gallery') || document.querySelector('media-gallery');
      const candidates = Array.from(productScope.querySelectorAll('[data-target]'));
      const trigger = candidates.find((el) => String(el.dataset.target || '').endsWith('-' + mediaId));
      const target = trigger?.dataset?.target;

      if (gallery && target && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(target, true);
        return;
      }

      const button = trigger?.querySelector('button');
      if (button && typeof button.click === 'function') button.click();
    };

    const updateMain = () => {
      let variant = currentBaseVariant();
      if (!variant?.available) {
        const kind = state.type === 'canvas' ? canvasValue : unframedValue;
        const fallback = variants.find((v) => v.available && v.options?.[0] === kind);
        if (fallback) {
          state.size = fallback.options[1];
          variant = fallback;
        }
      }
      if (mainButton) mainButton.disabled = !variant?.available;
      if (!variant) return;

      if (mainPrice) mainPrice.textContent = variant.priceText;
      if (mainButtonPrice) mainButtonPrice.textContent = variant.priceText;
      if (variantInput) variantInput.value = variant.id;

      sizeButtons.forEach((button) => {
        const sizeVariant = state.type === 'canvas'
          ? findVariant(canvasValue, button.dataset.lmSize)
          : findVariant(unframedValue, button.dataset.lmSize);
        button.disabled = !sizeVariant || !sizeVariant.available;
        const selected = button.dataset.lmSize === state.size;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-checked', selected ? 'true' : 'false');

        const rowPrice = button.querySelector('[data-lm-row-price]');
        if (rowPrice) {
          rowPrice.textContent = sizeVariant ? sizeVariant.priceText : '—';
        }
      });

      typeButtons.forEach((button) => {
        const kind = button.dataset.lmType === 'canvas' ? canvasValue : unframedValue;
        button.disabled = !variants.some((v) => v.available && v.options?.[0] === kind);
        button.classList.toggle('is-selected', button.dataset.lmType === state.type);
      });

      if (frameNote) frameNote.hidden = state.type !== 'print';
      updateMedia(variant);
    };

    // Keep the four frame choices visible. Only the current size's real
    // Shopify variants decide if a frame can be selected or purchased.
    const updateFrameModal = () => {
      const base = findVariant(unframedValue, state.size);
      if (!base) return;

      frameButtons.forEach((button) => {
        const frameValue = button.dataset.lmFrame;
        const variant = frameValue === '__NO_FRAME__'
          ? base
          : findVariant(framedValue, state.size, frameValue);
        const hasValidVariant = Boolean(variant && variant.available);
        // Never hide frame colors: a missing variant may be disabled, but
        // its option remains visible instead of vanishing from the dialog.
        button.hidden = false;
        button.disabled = !hasValidVariant;
        button.dataset.lmVariantId = variant?.id ? String(variant.id) : '';
        button.setAttribute('aria-pressed', frameValue === state.frame ? 'true' : 'false');

        const extraEl = button.querySelector('[data-lm-frame-extra]');
        if (extraEl) {
          extraEl.textContent = !hasValidVariant ? '—'
            : frameValue === '__NO_FRAME__' ? formatDelta(0)
            : formatDelta(Number(variant.price) - Number(base.price));
        }
        button.classList.toggle('is-selected', frameValue === state.frame);
      });

      const selected = currentFinalVariant();
      const validSelection = Boolean(selected && selected.available);
      if (continueButton) continueButton.disabled = !validSelection;
      if (continueLabel) {
        continueLabel.textContent =
          state.frame === '__NO_FRAME__'
            ? root.dataset.continueNoFrame
            : root.dataset.continueFrame;
      }
      const total = modal?.querySelector('[data-lm-frame-total-price]');
      if (total) total.textContent = selected?.priceText || base.priceText;
      // Never replace Fine Art Print's base price on the product page
      // while selecting a frame: upgrades are displayed in this modal only.
    };

    const openModal = () => {
      state.frame = '__NO_FRAME__';
      updateFrameModal();
      modal.hidden = false;
      document.body.classList.add('overflow-hidden');
      requestAnimationFrame(() => {
        modal?.querySelector('[data-lm-frame].is-selected')?.focus();
      });
    };

    const closeModal = (restoreBase = true) => {
      modal.hidden = true;
      document.body.classList.remove('overflow-hidden');
      if (restoreBase) {
        state.frame = '__NO_FRAME__';
        updateMain();
      }
      mainButton?.focus();
    };

    const submitVariant = (variant) => {
      if (!variant || !variant.available || !variantInput || !hiddenSubmit) return;
      variantInput.value = variant.id;
      hiddenSubmit.click();
    };

    typeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        state.type = button.dataset.lmType;
        state.frame = '__NO_FRAME__';

        const selectedExists = currentBaseVariant();
        if (!selectedExists?.available) {
          const fallback = sizeButtons.find((sizeButton) => {
            const v = state.type === 'canvas'
              ? findVariant(canvasValue, sizeButton.dataset.lmSize)
              : findVariant(unframedValue, sizeButton.dataset.lmSize);
            return v?.available;
          });
          if (fallback) state.size = fallback.dataset.lmSize;
        }

        updateMain();
      });
    });

    sizeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        state.size = button.dataset.lmSize;
        state.frame = '__NO_FRAME__';
        updateMain();
      });
    });

    frameButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled || !button.dataset.lmVariantId) return;
        state.frame = button.dataset.lmFrame;
        updateFrameModal();
      });
    });

    root.querySelectorAll('[data-lm-frame-close]').forEach((button) => {
      button.addEventListener('click', () => closeModal(true));
    });

    modal?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeModal(true);
    });

    mainButton?.addEventListener('click', () => {
      if (state.type === 'print') {
        openModal();
      } else {
        submitVariant(currentFinalVariant());
      }
    });

    continueButton?.addEventListener('click', () => {
      const variant = currentFinalVariant();
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      closeModal(false);
      submitVariant(variant);
    });

    // Keep the frame dialog outside the sticky/animated product container.
    // Attach listeners before moving it so the selection remains functional.
    if (modal && modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    syncCanvasGallery(null);
    updateMain();
    movePostPurchaseHelpers();
    requestAnimationFrame(movePostPurchaseHelpers);
    setTimeout(movePostPurchaseHelpers, 250);
  };

  const initAll = () => {
    document.querySelectorAll('[data-lm-ref-product]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
